var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('keep-alive',[_c('router-view',{staticClass:"appView"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }